import { makeStyles } from "@material-ui/styles";

export default makeStyles((theme) => ({
  root: {
    width: "100vw",
    height: "100vh",
    zIndex: 1000000,
    backgroundColor: "rgba(0,0,0,0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    position: "fixed",
    top: 0,
    left: 0,
  },
  paper: {
    width: "70vw",
    minHeight: 200,
    maxHeight: "90vh",
    height: "auto",
    position: "relative",
  },
  close: {
    position: "absolute",
    width: 30,
    top: 5,
    right: 5, // برعکسه چون ارتی اله
    cursor: "pointer"
  },
  title: {
    width: "100%",
    padding: '10px 0 ',
    textAlign: "center",
    alignItems: "center"
  },
  form: {
    width: "100%",
    minHeight: 200,
    maxHeight: "80vh",
    overflowY: "auto",
    overflowX: "hidden",
    padding: "50px 25px",
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
    // flexDirection: "column",
  },

}));
